import React, { useEffect, useState } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { updateDefaultFieldsArray } from "../../../../ReusableComponents/Table/function";
import Highlighter from "react-highlight-words";
import { flattenObjectsInArray } from "../../../../utils/functions";
import { FaMoneyCheck, FaUserEdit } from "react-icons/fa";
import { HiOutlineSquaresPlus } from "react-icons/hi2";
import GroupActionPopup from "./GroupActionPopup";
import DownloadPDFPopup from "./DownloadPDFPopup";
import { AiOutlineCloudDownload, AiOutlineCloudUpload } from "react-icons/ai";
import ArrivalEmployeeReport from "./excels/ArrivalEmployeeReport";
import SettingsPopup from "../../../../ReusableComponents/SettingsPopup/SettingsPopup";
import { IoSettingsOutline } from "react-icons/io5";
import { VscCloudDownload } from "react-icons/vsc";
import DownloadPDFPopupArrival from "./DownlaodArrivalEmployeePDF";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { axios } from "../../../../Global";
import { Tooltip } from "react-tooltip";
import { checkAccessFn } from "../../../../utils/checkAccess";

export default function ArrivalEmployeeBatch({
  candidateData,
  setUpdatedData,
  batchData = [],
  sector,
  arrivalBatchId,
  rowData,
  setOpenArrivalEmployeeBatch,
  fullBatchData,
}) {
  const dispatch = useDispatch();
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) => checkAccessFn(dashboardData, module, name);

  const [checkedList, setCheckedList] = useState([]);
  const [groupDownloadPopupStateDocument, setgroupDownloadPopupStateDocument] =
    useState({
      open: false,
    });
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    setCheckedList([]);
    const selectedBatch = fullBatchData?.find(
      (data) => data?.id == arrivalBatchId
    );
    if (!selectedBatch) {
      setTableData([]);
    } else {
      const candidateArray = selectedBatch?.candidate;
      // if (
      //   (countPaxNotCompleted(candidateArray) > 0 ||
      //     candidateStatusTravelling(candidateArray)) &&
      //   selectedBatch?.pax > 0
      // ) {
      const updatedData = [];
      for (let data of candidateArray) {
        updatedData.push({ ...data, arrival_sector: sector });
      }
      setTableData(flattenObjectsInArray(updatedData));
      // } else {
      //   setOpenArrivalEmployeeBatch({ open: false });
      // }
    }
  }, [fullBatchData, arrivalBatchId]);
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(tableData);

  const [searchWords, setSearchWords] = useState([]);

  const [defaultFields, setDefaultFields] = useState([]);
  const [selectedFields, setSelectedFields] = useState([]);

  const [groupActionPopup, setGroupActionPopup] = useState({
    open: false,
    type: null,
  });

  const [groupDownloadPopupState, setgroupDownloadPopupState] = useState({
    open: false,
  });

  const handleSelectAll = () => {
    if (checkedList?.length == currentList?.length) {
      setCheckedList([]);
    } else {
      setCheckedList(currentList.map((data) => data?.id));
    }
  };
  const [DocumentData, setDocumentData] = useState([]);
  const [clientList, setClientList] = useState();
  const token = localStorage.getItem("token");
  useEffect(() => {
    // setListLoading(true)
    axios
      .get("/dashboard/company", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setClientList(res?.data?.data?.company || []);
        // setListLoading(false);
      })
      .catch((err) => {
        // setListLoading(false);
        dispatch(
          setAppError({
            msg: err.message,
          })
        );
      });
  }, []);

  const handleCheckBox = (rowId, row) => {
    console.log("row data to be seen here....", row);
    if (checkedList.includes(rowId)) {
      setCheckedList((prevData) => prevData.filter((id) => id != rowId));
      setDocumentData((prevData) => prevData.filter((id) => id != row.id));
    } else {
      setCheckedList((prevData) => [...prevData, rowId]);
      setDocumentData((prevData) => [...prevData, row]);
    }
  };

  const order = [
    "name",
    "passport_number",
    "candidate_id",
    "religion",
    "nationality_name",
    "company_name",
    "loan_advance",
    "loan_advance_installment",
    "not_travelled_instance",
    "job_position_name",
    "visa_block_number",
    "visa_profession_name",
    "status",
  ];

  const options = [
    { value: "candidate_id", title: "Employee ID" },
    { value: "name", title: "Employee Name" },
    { value: "loan_advance_installment", title: "Installment" },
    { value: "nationality_name", title: "Country" },
    { value: "company_name", title: "VISA Provider" },
    { value: "not_travelled_instance", title: "Travelling Instance" },
    { value: "status", title: "Status" },
    { value: "job_position_name", default: false },
    { value: "visa_block_number", default: false },
    { value: "visa_profession_name", default: false },
  ];
  console.log("tableData....print values",tableData,order,options)
  useEffect(() => {
    const currentDefaultFields = updateDefaultFieldsArray({
      tableData,
      order,
      options,
    });
    setDefaultFields(currentDefaultFields);
    setSelectedFields(currentDefaultFields?.filter((data) => data.default));
  }, [tableData]);

  useEffect(() => {}, [selectedFields]);

  const [showSettings, setShowSettings] = useState(false);
  console.log("checkedList.......list......", DocumentData);
  return (
    <>
      <Tooltip
        id="update-visa-details-tooltip"
        place="bottom"
        className="z-50 max-w-sm w-full"
        opacity="1"
      />
      {groupActionPopup.open && (
        <GroupActionPopup
          popupState={groupActionPopup}
          setPopupState={setGroupActionPopup}
          setTableData={setUpdatedData}
          checkedList={checkedList}
          arrivalBatchId={arrivalBatchId}
          groupDownloadPopupStateDocument={tableData}
        />
      )}
      {groupDownloadPopupStateDocument.open && (
        <DownloadPDFPopupArrival
          popupState={groupDownloadPopupStateDocument}
          setPopupState={setgroupDownloadPopupStateDocument}
          selectedRowsData={tableData?.filter((data) =>
            checkedList.includes(data?.id)
          )}
          company={clientList ? clientList : []}
        />
      )}
      {groupDownloadPopupState.open && (
        <DownloadPDFPopup
          popupState={groupDownloadPopupState}
          setPopupState={setgroupDownloadPopupState}
          selectedRowsData={candidateData?.filter((data) =>
            checkedList.includes(data?.id)
          )}
        />
      )}
      {showSettings && (
        <SettingsPopup
          showPopup={showSettings}
          setShowPopup={setShowSettings}
          initialState={defaultFields}
          finalState={selectedFields}
          setFinalState={setSelectedFields}
          order={order}
        />
      )}

      <div className={"pt-2 mt-10"}>
        <h2 className="text-lg font-bold text-slate-700">
          ARRIVAL BATCH EMPLOYEE DETAILS:
        </h2>
        <div
          className={
            tableData?.length <= 0 ? "hidden" : "flex justify-between items-end"
          }
        >
          <div className="flex flex-wrap gap-5 w-full items-center">
            <div className="flex gap-3 items-center pt-2">
              <Search
                keywords={defaultFields.map((data) => data.value)}
                setSearchWords={setSearchWords}
              />
            </div>
            <div className="relative">
              <div className="peer pt-2">
                <button className="flex items-center gap-2 bg-blue text-white p-2 px-3  rounded-md w-fit text-xs text-center ">
                  Group Action <HiOutlineSquaresPlus size={"1.2rem"} />
                </button>
              </div>
              <div
                className={
                  "hidden absolute -top-[5.5rem] left-1/2 transform -translate-x-1/2 max-w-xs w-[12rem] h-auto bg-white shadow-xl rounded-lg p-2 ring-1 ring-slate-400  peer-hover:flex hover:flex flex-col gap-1"
                }
              >
                {checkAccess("ARRIVAL / ONBOARDING", "arrival-onboarding-edit") && (
                  <button
                    onClick={() =>
                      setGroupActionPopup({ open: true, type: "status" })
                    }
                    disabled={checkedList.length == 0}
                    className="flex justify-center items-center gap-2 bg-blue text-white p-2 px-3 rounded-md w-full text-xs text-center disabled:bg-blue/70 disabled:cursor-not-allowed "
                  >
                    Change Status <FaUserEdit size={"1.1rem"} />
                  </button>
                )}
                {checkAccess("ARRIVAL / ONBOARDING", "arrival-onboarding-edit") && (
                  <button
                    onClick={() =>
                      setGroupActionPopup({ open: true, type: "loan_advance" })
                    }
                    disabled={checkedList.length == 0}
                    className="flex justify-center items-center gap-2 bg-red text-white p-2 px-3 rounded-md w-full text-xs text-center disabled:bg-red/70 disabled:cursor-not-allowed "
                  >
                    Loan Advance <FaMoneyCheck size={"1.1rem"} />
                  </button>
                )}
              </div>
            </div>
            <div className="pt-2">
              <button
                onClick={() => setgroupDownloadPopupState({ open: true })}
                disabled={checkedList.length == 0}
                className="p-2 px-4 rounded-md bg-blue uppercase disabled:bg-gray text-white min-w-fit text-xs flex items-center gap-2 disabled:bg-blue/70 disabled:cursor-not-allowed "
              >
                <p>Download Loan Request Form</p>
                <AiOutlineCloudDownload size={"1.2rem"} />
              </button>
            </div>
            <div
              className="pt-2"
              data-tooltip-id="update-visa-details-tooltip"
              data-tooltip-content="Candidate Documents - EMPLOYEE ABSENTEEISM POLICY, EMPLOYMENT AGREEMENT"
            >
              <button
                onClick={() =>
                  setgroupDownloadPopupStateDocument({ open: true })
                }
                disabled={checkedList.length == 0}
                className="p-2 px-4 rounded-md bg-blue uppercase disabled:bg-gray text-white min-w-fit text-xs flex items-center gap-2 disabled:bg-blue/70 disabled:cursor-not-allowed "
              >
                <p>Download DOCUMENT</p>
                <VscCloudDownload size={"1.2rem"} />
              </button>
            </div>
            <button
              className="flex items-center gap-2 bg-blue text-white p-2 px-3 mt-2  rounded-md w-fit text-xs text-center disabled:bg-blue/70 disabled:cursor-not-allowed"
              onClick={() =>
                ArrivalEmployeeReport("Arrival-Employee-Report", currentList)
              }
              disabled={currentList?.length <= 0}
            >
              <p>Download Arrival Batch Employee Report</p>
            </button>
            <button
              onClick={() => setShowSettings(true)}
              className="pt-2  disabled:cursor-not-allowed"
              disabled={currentList.length <= 0}
            >
              <IoSettingsOutline size={"1.2rem"} />
            </button>
          </div>
          <div>
            <p className="text-sm w-full text-right font-medium mb-1  block">{`Slide / scroll to right >`}</p>
            <CountPerPage />
          </div>
        </div>
        <div className="w-full max-w-sm my-3 mt-5 grid grid-cols-[1rem,1fr] items-center text-sm justify-start gap-3">
          <div className="w-3 h-3 bg-[#D3D3D3]"></div>
          <p>LOAN & STATUS NOT UPDATED</p>
          <div className="w-3 h-3 bg-[#ADD8E6]"></div>
          <p>LOAN UPDATED</p>
          <div className="w-3 h-3 bg-[#90EE90]"></div>
          <p>LOAN AND STATUS UPDATED</p>
        </div>
        <div
          className={
            tableData?.length <= 0
              ? " bg-slate-50 shadow rounded-lg px-1 mt-10 p-5 transition-all w-full min-w-full  h-auto"
              : "hidden"
          }
        >
          <p className="text-center">Employee Details Not Found</p>
        </div>
        <div
          className={
            tableData?.length <= 0
              ? "hidden"
              : ` bg-slate-50 shadow rounded-lg px-1 transition-all w-full min-w-full  h-auto`
          }
        >
          <div className="py-3 px-3 flex gap-3 justify-between items-center text-sm">
            <div className="flex gap-3 items-center">
              <h2 style={{ fontWeight: 900 }}>
                {rowData?.candidate[0]?.project?.client?.name}
              </h2>
              <p>|</p>
              <h2 style={{ fontWeight: 900 }}>{rowData?.flight_details}</h2>
            </div>
            <div>
              <h2>
                Remaining Pax - {countPaxNotCompleted(tableData)} /{" "}
                {rowData?.pax}
              </h2>
            </div>
          </div>
          <div
            className={`rounded-md overflow-x-scroll py-5 flex flex-col bg-white p-3 mb-2`}
          >
            <div className="flex justify-between gap-5 min-w-full w-fit">
              <div
                className="max-w-[8rem] min-w-[4rem] w-full font-semibold  cursor-pointer "
                onClick={handleSelectAll}
              >
                <p className="">Select</p>
                <div className="flex gap-2 ">
                  <p className="">All</p>
                  <input
                    type="checkbox"
                    defaultChecked={false}
                    checked={
                      checkedList?.length == currentList?.length &&
                      currentList.length > 0
                    }
                    className="checkbox checkbox-sm"
                  />
                </div>
              </div>
              <p className={`font-semibold w-full min-w-[4rem] max-w-[5rem]`}>
                Sl No.
              </p>
              {selectedFields.map((selectedData) => (
                <div key={selectedData.id} className="flex flex-col gap-2">
                  <p
                    className={`font-semibold w-full min-w-[10rem] ${selectedData.width}`}
                  >
                    {selectedData?.title}
                  </p>
                </div>
              ))}
            </div>

            {tableData?.length <= 0 && (
              <NoDataFound className="col-span-full" />
            )}
            <div className="min-w-full w-fit  flex flex-col gap-y-1 mt-4">
              {tableData?.length > 0 &&
                currentList
                  ?.sort((a, b) => {
                    const orderA = getColorOrder(a);
                    const orderB = getColorOrder(b);

                    // Compare the orders
                    return orderA - orderB;
                  })
                  ?.map((data, index) => (
                    <div
                      style={
                        data?.loan_advance === null ||
                        (data?.loan_advance_installment === null &&
                          data.status != "ARRIVED")
                          ? { background: "#D3D3D3" }
                          : data?.loan_advance !== null &&
                              data?.loan_advance_installment !== null &&
                              data.status != "ARRIVED"
                            ? { background: "#ADD8E6" }
                            : data?.loan_advance !== null &&
                              data?.loan_advance_installment !== null &&
                              data.status == "ARRIVED" && {
                                background: "#90EE90",
                              }
                      }
                      key={data?.id}
                      className={`flex flex-col gap-3  pt-2 `}
                    >
                      <div className="flex justify-between gap-5 min-w-full w-fit">
                        <div className="w-full max-w-[8rem] min-w-[4rem] flex justify-center">
                          <input
                            type="checkbox"
                            checked={checkedList.includes(data?.id)}
                            onChange={() => handleCheckBox(data?.id, data)}
                            className="checkbox checkbox-sm"
                          />
                        </div>
                        <div className=" w-full min-w-[4rem] max-w-[5rem]">
                          <PaginationIndex index={index} />
                        </div>
                        {selectedFields.map((selectedData) => (
                          <div
                            key={selectedData.id}
                            className="flex flex-col gap-2"
                          >
                            <p
                              className={`w-full min-w-[10rem] ${selectedData.width}`}
                            >
                              <Highlighter
                                searchWords={searchWords}
                                autoEscape={true}
                                textToHighlight={
                                  data[selectedData.value] !== undefined &&
                                  data[selectedData.value] !== null
                                    ? (selectedData.value === "date_of_departure" || selectedData.value === "date_of_arrival")
                                      ? String(data[selectedData.value]).slice(0, 10)
                                      : String(data[selectedData.value])
                                    : "-" || ""
                                }
                              />
                            </p>
                          </div>
                        ))}
                      </div>
                      <hr className="border-[1.5px] border-slate-100  min-w-full" />
                    </div>
                  ))}
            </div>
          </div>
          <Pagination />
        </div>
      </div>
    </>
  );
}

export function countPaxNotCompleted(array) {
  let count = 0;
  array.forEach((obj) => {
    if (
      obj?.loan_advance === null ||
      obj?.loan_advance_installment === null ||
      obj.status != "ARRIVED"
    ) {
      count++;
    }
  });
  return count;
}
export function candidateStatusTravelling(array = []) {
  return array.every((obj) => obj?.status != "ARRIVED");
}

const getColorOrder = (data) => {
  if (data?.loan_advance === null || data?.loan_advance_installment === null) {
    return 1;
  } else if (
    data?.loan_advance !== null &&
    data?.loan_advance_installment !== null &&
    data.status !== "ARRIVED"
  ) {
    return 2;
  } else if (
    data?.loan_advance !== null &&
    data?.loan_advance_installment !== null &&
    data.status === "ARRIVED"
  ) {
    return 3;
  }

  // Default order if none of the conditions match
  return 0;
};
